import React from 'react';
import type { ComponentType } from '@ext-bookmark/shared/types';

interface ComponentSelectorProps {
  parentId?: string;
  parentType?: ComponentType;
  onSelect: (componentType: ComponentType) => void;
  onCancel: () => void;
}

const ComponentSelector: React.FC<ComponentSelectorProps> = ({
  onSelect,
  onCancel,
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]" onClick={onCancel}>
      <div 
        onClick={(e) => e.stopPropagation()}
        className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-6 w-full max-w-md mx-4"
      >
        <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white">选择组件类型</h3>
        <div className="space-y-2">
          <button
            onClick={() => onSelect('section')}
            className="w-full px-4 py-3 text-left bg-gray-50 dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 rounded-lg transition-colors"
          >
            <div className="font-medium text-gray-900 dark:text-white">分区</div>
            <div className="text-sm text-gray-500 dark:text-gray-400">用于组织书签的分区组件</div>
          </button>
        </div>
        <div className="mt-4 flex justify-end">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
          >
            取消
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComponentSelector;
